import { ListItemNode, ListNode, $isListNode } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export function ListNormalizationPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerNodeTransform(ListItemNode, (node) => {
        const children = node.getChildren();
        const nestedLists = children.filter((child): child is ListNode => $isListNode(child));
        if (nestedLists.length === 0) return;

        const nonListChildren = children.filter((child) => !$isListNode(child));
        const hasTextContent = nonListChildren.some(
          (child) => child.getTextContent().trim().length > 0,
        );
        if (hasTextContent) return;

        const previousSibling = node.getPreviousSibling();
        if (previousSibling instanceof ListItemNode) {
          const prevNode = previousSibling;
          nestedLists.forEach((list) => {
            const lastChild = prevNode.getLastChild();
            if ($isListNode(lastChild) && lastChild.getListType() === list.getListType()) {
              list.getChildren().forEach((child) => lastChild.append(child));
              list.remove();
            } else {
              prevNode.append(list);
            }
          });
          node.remove();
          return;
        }

        const parent = node.getParent();
        if (parent && $isListNode(parent)) {
          nestedLists.forEach((list) => node.insertBefore(list));
          node.remove();
        }
      }),
    [editor],
  );

  return null;
}
